<template>
  <div class="modal fade show d-block" tabindex="-1" style="background-color: rgba(0,0,0,0.5);">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{$t('add_team_member')}}</h5>
          <button type="button" class="btn-close" @click="close"></button>
        </div>
        <div class="modal-body">
          <form @submit.prevent="submit">
            <div class="mb-3">
              <label class="form-label">{{$t('user')}} *</label>
              <div v-if="availableUsers.length === 0 && !loadingUsers" class="alert alert-info small py-2">
                <AppIcon name="bi-info-circle" class="bi bi-info-circle me-1" /> {{$t('all_users_already_assigned') || 'All users are already assigned to this project.'}}
              </div>
              <select v-else class="form-select" v-model="form.user_id" required>
                <option value="">{{$t('select_user')}}</option>
                <option v-for="user in availableUsers" :key="user.id" :value="user.id">
                  {{ user.name }}
                </option>
              </select>
            </div>

            <div class="mb-3">
              <label class="form-label">{{$t('role')}}</label>
              <select class="form-select" v-model="form.role">
                <option value="viewer">{{$t('viewer')}}</option>
                <option value="contributor">{{$t('contributor')}}</option>
                <option value="manager">{{$t('manager')}}</option>
                <option value="owner">{{$t('owner')}}</option>
              </select>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="close">{{$t('cancel')}}</button>
          <button type="button" class="btn btn-primary" @click="submit" :disabled="loading || !form.user_id">
            <span v-if="loading" class="spinner-border spinner-border-sm me-2"></span>
            {{$t('add')}}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import helper from '../../helper'

export default {
  name: 'AddTeamModal',
  props: {
    projectId: {
      type: String,
      required: true
    },
    existingAssignments: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      form: {
        user_id: '',
        role: 'contributor'
      },
      users: [],
      loadingUsers: false,
      loading: false
    }
  },
  computed: {
    availableUsers() {
      // Filter out users who are already assigned to the project
      const assignedUserIds = this.existingAssignments
        .filter(a => !a.task_id)
        .map(a => a.user_id)
      return this.users.filter(user => !assignedUserIds.includes(user.id))
    }
  },
  mounted() {
    this.loadUsers()
  },
  methods: {
    async loadUsers() {
      this.loadingUsers = true
      try {
        // Get all users from the business
        const response = await helper.customGet(`${process.env.VUE_APP_API}/project-management/users`)
        this.users = response.data || []
      } catch (error) {
        alert('Error loading users:', error)
      } finally {
        this.loadingUsers = false
      }
    },
    async submit() {
      if (helper.checkAccess('edit_projects') <= 0) return
      if (!this.form.user_id) {
        return
      }
      this.loading = true
      try {
        await helper.customPost(`${process.env.VUE_APP_API}/projects/${this.projectId}/assign`, this.form, { showToast: true })
        this.$emit('refresh')
        this.close()
      } catch (error) {
        alert('Error adding member:', error)
      } finally {
        this.loading = false
      }
    },
    close() {
      this.$emit('close')
    }
  }
}
</script>
